import PropTypes from 'prop-types';
import React from 'react';

import { t } from '../../../../services/i18nService';
import styles from '../../testOverview.scss';

import liveSessioner from '../../../../services/livesession/LiveSessioner';
import ConfirmHardwareSettingsContainer from './ConfirmHardwareSettings';
import ExitTestButton from './../../ExitTestButton';
import GrantHardwareAccessButton from './GrantHardwareAccessButton';

class TestComponentHardwareAccessCheck extends React.PureComponent {
    static propTypes = {
        offerGrantAccess: PropTypes.bool.isRequired,
        offerRetryRequestAccess: PropTypes.bool.isRequired,
        offerSwitchDevice: PropTypes.bool.isRequired,
        statusDescription: PropTypes.string,
    };

    handleRetryRequestAccess = () => {
        liveSessioner.requestHardwareAccess();
    }

    render() {
        const {
            offerGrantAccess,
            offerRetryRequestAccess,
            offerSwitchDevice,
            statusDescription,
        } = this.props;

        return (
            <React.Fragment>
                { statusDescription &&
                    <div className={styles.hardwareDescription}>{statusDescription}</div>
                }

                { offerGrantAccess && <GrantHardwareAccessButton /> }

                { offerSwitchDevice && <ConfirmHardwareSettingsContainer /> }

                { offerRetryRequestAccess &&
                    <div>
                        <button className={`${styles.button} btn`} onClick={this.handleRetryRequestAccess} >
                            {t('hardwareAccessCheck.retryHardwareSettings')}
                        </button>
                        <span className={styles.orSeparator}>{t('general.or')}</span>
                        <ExitTestButton showButtonForNonLockdown />
                    </div>
                }
            </React.Fragment>
        );
    }
}

export default TestComponentHardwareAccessCheck;
